export default {
  SET_CURRENT_EXERCISE(state, payload) {
    state.currentExercise = payload;
  },
  SET_CURRENT_STEP(state, payload) {
    state.currentStep = payload;
  },
  SAVE_LOG(state, { key, payload }) {
    state.logs[key] = payload;
  },
};
